import { $SERVER } from "~/util/Loaders";
import { $API } from "~/util/Loaders";
import { z } from "zod";
import { Register } from "~/lib/auth/register.server";

export const authRegisterApi = $API({
  path: "api/auth/register",
  method: "POST",
  parser: z
    .object({
      login: z.string(),
      pswd: z.string(),
      email: z.string(),
      timezone: z.string(),
    })
    .strict(),
})(
  $SERVER?.(async (cx) => {
    const { input, req } = cx;

    const result = await Register({ input });
    switch (result.t) {
      case "success":
        // await signIn(cx.res, );
        return result;
      case "error":
        return result;
    }
  })
);
